module.exports = __webpack_public_path__ + "media/customizations/sundancenorthlife/back-6b8c4d7f5abaef8b226326939469c9de.jpg";